// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Void = void 0;
exports.Void = {};
//# sourceMappingURL=types.js.map